import React, { createContext, useState, useRef } from 'react';
import WithBullseyeLocator from '../WithBullseyeLocator/WithBullseyeLocator';

const defaultState = {
  bladeState: false,
  closeAllMenusOnEsc: () => null,
  resetState: () => null,
  setBladeState: (_bladeState: boolean) => null,
};

const Context = createContext(defaultState);

const Provider = WithBullseyeLocator(
  ({
    children,
    origin,
    nearbyStores,
    autoCompleteInput,
    getCurrentLocation,
    allStoreLogos,
    isGoogleLoaded,
    setInputRef,
    placeName,
    setStoreToDisplay,
    storeToDisplay,
    showSelectBtn,
    setShowSelectBtn,
    options,
    toggleUserFilters,
    searchByQuery,
  }) => {
    const bladeRef = useRef(null);
    const [bladeState, setBladeState] = useState(false);
    const [hideBookAppointment, setHideBookAppointment] = useState(false);

    const resetState = () => setBladeState(false);

    const closeAllMenusOnEsc = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        resetState();
      }
    };

    const scrollToTop = () => {
      if (bladeRef.current) {
        const { id } = bladeRef.current.props;
        const root = document.querySelector(`#${id}`);
        const menu = root.querySelector('div.bm-menu');
        menu.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      }
    };

    return (
      <Context.Provider
        value={{
          bladeState,
          setBladeState,
          closeAllMenusOnEsc,
          resetState,
          origin,
          nearbyStores,
          autoCompleteInput,
          getCurrentLocation,
          allStoreLogos,
          isGoogleLoaded,
          setInputRef,
          placeName,
          setStoreToDisplay,
          storeToDisplay,
          showSelectBtn,
          setShowSelectBtn,
          scrollToTop,
          bladeRef,
          options,
          toggleUserFilters,
          searchByQuery,
          hideBookAppointment,
          setHideBookAppointment,
        }}
      >
        {children}
      </Context.Provider>
    );
  },
);

export { Context, Provider };
